<template>
    <b-modal ref="modal" v-bind="$attrs" size="md" :id="id" :title="`Kualitas Udang`" @ok="handleOk" title-class="font-18" hide-footer body-class="modal-body-fluid" centered>
        <template #modal-header-close>
            <div>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="#30345B" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM14.3 14.3C14.2075 14.3927 14.0976 14.4663 13.9766 14.5164C13.8557 14.5666 13.726 14.5924 13.595 14.5924C13.464 14.5924 13.3343 14.5666 13.2134 14.5164C13.0924 14.4663 12.9825 14.3927 12.89 14.3L10 11.41L7.11 14.3C6.92302 14.487 6.66943 14.592 6.405 14.592C6.14057 14.592 5.88698 14.487 5.7 14.3C5.51302 14.113 5.40798 13.8594 5.40798 13.595C5.40798 13.4641 5.43377 13.3344 5.48387 13.2135C5.53398 13.0925 5.60742 12.9826 5.7 12.89L8.59 10L5.7 7.11C5.51302 6.92302 5.40798 6.66943 5.40798 6.405C5.40798 6.14057 5.51302 5.88698 5.7 5.7C5.88698 5.51302 6.14057 5.40798 6.405 5.40798C6.66943 5.40798 6.92302 5.51302 7.11 5.7L10 8.59L12.89 5.7C12.9826 5.60742 13.0925 5.53398 13.2135 5.48387C13.3344 5.43377 13.4641 5.40798 13.595 5.40798C13.7259 5.40798 13.8556 5.43377 13.9765 5.48387C14.0975 5.53398 14.2074 5.60742 14.3 5.7C14.3926 5.79258 14.466 5.90249 14.5161 6.02346C14.5662 6.14442 14.592 6.27407 14.592 6.405C14.592 6.53593 14.5662 6.66558 14.5161 6.78654C14.466 6.90751 14.3926 7.01742 14.3 7.11L11.41 10L14.3 12.89C14.68 13.27 14.68 13.91 14.3 14.3Z"
                        fill="#30345B" />
                </svg>
            </div>
        </template>
        <div>
            <div class="row p-0 m-0">
                <template v-for="(quality, index) in qualities" >
                    <span v-bind:key="index" class="p-0">
                        <div class="row col-12 p-0 m-0 px-3">
                            <div class="col-3 d-flex align-items-center justify-content-center">
                                <div class="title-wrapper w-100 h-100 d-flex justify-content-center align-items-center">
                                    <span v-html="quality.title" class="text-center"></span>
                                </div>
                            </div>
                            <div :class="`${quality.contentClass ? quality.contentClass : 'col-7 p-0'}`"><span v-html="quality.content"></span></div>
                            <div :class="`${quality.iconClass ? quality.iconClass : 'col-2 d-flex align-items-center justify-content-end'}`">
                                <component :is="quality.icon"></component>
                            </div>
                        </div>
                        <div class="mt-0 p-0">
                            <hr v-if="index !== qualities.length - 1"/>
                        </div>
                    </span>
                </template>
            </div>
        </div>
    </b-modal>
</template>

<script>

import Icons from '@/assets/icons';

export default {
    na: 'ShrimpQualityModal',
    props: {
        id: {
            type: String,
            default: 'shrimp-quality-modal'
        },
    },
    data(){
        return {
            qualities: [
                {
                    'title': 'Fresh',
                    'content': `Kualitas <span class="bold">Fresh</span> merupakan kualitas udang yang paling super ditandai dengan kulitnya yang keras, warnanya segar dan memiliki anggota tubuh yang lengkap.`,
                    'icon': Icons.ShrimpQualityFresh
                },
                {
                    'title': 'Kulit Muda<br>(KM)',
                    'content': `Udang <span class="bold">Kulit Muda</span> merupakan udang yang fase moulting. Biasannya dicirikan dengan kulitnya yang lebih lembek namun secara warna, hampir mirip dengan fresh.`,
                    'icon': Icons.ShrimpQualityKM
                },
                {
                    'title': 'Below Standard<br>(BS)',
                    'content': `Ciri utama pada udang <span class="bold">Below Standard</span> yaitu warnanya merah, anggota tubuhnya tidak lengkap serta berbau.`,
                    'icon': Icons.ShrimpQualityBS,                    
                    'contentClass': 'col-7 pe-3 ps-0'
                },
                {
                    'title': 'Under Size<br>(US)',
                    'content': `Udang <span class="bold">Under Size</span> masuk kedalam golongan udang fresh namun biasanya dalam satu partai kolam saat panen ukuran udang tersebut lebih kecil dari ukuran yang tersampling.`,
                    'icon': Icons.ShrimpQualityUS,
                    contentClass: 'col-8 p-0',
                    iconClass: 'col-1 d-flex align-items-center justify-content-start'
                },
                {
                    'title': 'Merah',
                    'content': `Udang berwarna <span class="bold">Merah</span> dapat terjadi jika udang tidak disimpan dengan suhu yang dingin sehingga kondisinya memburuk dan terjadi pertumbuhan bakteri.`,
                    'icon': Icons.ShrimpQualityRed
                },
            ]
        }
    },
    methods: {
        handleOk(){

        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .close {
        opacity: 1 !important;
    }

    .title-wrapper {
        background: #F3F7FA;
    }
    
    .bold {
        color: #F37021;
        font-weight: 800;
    }

    * {
        font-family: 'Lato' !important;
    }

    .title-wrapper {
        font-weight: 600;
    }

    @media (min-width: 576px){
        .modal-dialog {
            max-width: 550px;
            margin: 28px auto;
        }
    }
    .modal-body-fluid {
        padding-inline: 0px !important;
        padding-bottom: 18px;
    }
}
</style>